import React, { memo, useCallback } from 'react'

import { string, bool, func, number } from 'prop-types'

import { getExtensionFromUrl } from 'Pods/Shared/ItemPageComponents/GalleryArea/Utils/getExtensionFromUrl'

function GenericVideoSlide({ fileUrl, isActiveSlide, onLoad, slideIndex }) {
  const handleLoad = useCallback(() => {
    if (onLoad) {
      onLoad(slideIndex)
    }
  }, [onLoad, slideIndex])

  if (!isActiveSlide) {
    return null
  }

  const extension = getExtensionFromUrl(fileUrl)

  return (
    <div className="gallery-area-top-carousel__video-wrapper">
      <video
        className="gallery-area-top-carousel__video"
        controls
        muted
        autoPlay
        onLoadedData={handleLoad}
        aria-label="Video"
      >
        <source src={fileUrl} type={extension}/>
      </video>
    </div>
  )
}

GenericVideoSlide.propTypes = {
  fileUrl: string.isRequired,
  isActiveSlide: bool.isRequired,
  onLoad: func,
  slideIndex: number,
}

export default memo(GenericVideoSlide)

